import { API_URL } from '../../../utils/config';

export const SEARCH_INSTALLATION_FIELD_SERVICE_ZONE_URL = `${API_URL}/fieldservicezone/1`;
export const REGISTER_FIELD_SERVICE_ZONE_URL = `${API_URL}/fieldservicezone`;
